import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth';

/** Chrome shared by both consoles: brand, nav, identity, sign out. */
export function Layout({ nav }: { nav: Array<{ to: string; label: string; end?: boolean }> }) {
  const { session, logout } = useAuth();

  const identity =
    session?.kind === 'superuser'
      ? { primary: session.superuser.email, secondary: 'Superadmin' }
      : session?.kind === 'user'
        ? {
            primary: session.user.email,
            secondary: `${session.application?.name ?? 'Application'} · ${
              session.user.isMaster ? 'Master' : 'Member'
            }`,
          }
        : null;

  return (
    <div className="shell">
      <header className="topbar">
        <div className="topbar__brand">
          <span className="brand-mark" aria-hidden="true" />
          <span>IndiaHMIS Auth</span>
        </div>

        <nav className="topbar__nav">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `navlink ${isActive ? 'navlink--active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="topbar__user">
          {identity && (
            <div className="identity">
              <span className="identity__primary">{identity.primary}</span>
              <span className="identity__secondary">{identity.secondary}</span>
            </div>
          )}
          <button type="button" className="btn btn--small" onClick={logout}>
            Sign out
          </button>
        </div>
      </header>

      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
